import React, { useState } from 'react';
import './qualification.css';

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className='qualification section'>
      <h2 className='section__title'>Qualification</h2>
      <span className='section__subtitle'>My professional journey</span>

      <div className='qualification__container container'>
        <div className='qualification__tabs'>
          <div
            className={
              toggleState === 1
                ? 'qualification__button qualification__active button--flex active-qualification'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(1)}
          >
            <i className='uil uil-graduation-cap qualification__icon'></i>
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? 'qualification__button qualification__active button--flex active-qualification'
                : 'qualification__button button--flex'
            }
            onClick={() => toggleTab(2)}
          >
            <i className='uil uil-briefcase-alt qualification__icon '></i>
            Experience
          </div>
        </div>

        <div className='qualification__sections'>
          {/* ===================== EDUCATION ===================== */}
          <div
            className={
              toggleState === 1
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }
          >
            {/* MSc */}
            <div className='qualification__data'>
              <div>
                <h3 className='qualification__title'>MSc in Computer Science</h3>
                <span className='qualification__subtitle'>
                  Teesside University (Middlesbrough, UK)
                </span>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> Sep 2023 - May 2025
                </div>
              </div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            {/* B.Tech */}
            <div className='qualification__data'>
              <div></div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>

              <div>
                <h3 className='qualification__title'>
                  B.Tech in Computer Science & Engineering
                </h3>
                <span className='qualification__subtitle'>
                  Swarnandhra College of Engineering & Technology (India)
                </span>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> Aug 2019 - Apr 2023
                </div>
              </div>
            </div>
          </div>

          {/* ===================== EXPERIENCE ===================== */}
          <div
            className={
              toggleState === 2
                ? 'qualification__content qualification__content-active'
                : 'qualification__content'
            }
          >
            {/* Research Intern */}
            <div className='qualification__data'>
              <div>
                <h3 className='qualification__title'>
                  Research Intern (Machine Learning)
                </h3>
                <span className='qualification__subtitle'>
                  Teesside University (Middlesbrough, UK)
                </span>
                <p className='qualification__description'>
                  Designed and trained deep learning models for medical image
                  classification (Monkeypox detection). Performed preprocessing
                  and augmentation, evaluated models with standard metrics, and
                  integrated inference into a Flask-based web application.
                </p>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> Jan 2024 - Jul 2024
                </div>
              </div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            {/* ML Intern */}
            <div className='qualification__data'>
              <div></div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>

              <div>
                <h3 className='qualification__title'>Machine Learning Intern</h3>
                <span className='qualification__subtitle'>
                  TechnoLabs AI Solutions (Remote, India)
                </span>
                <p className='qualification__description'>
                  Built machine learning pipelines with Python and scikit-learn,
                  including data cleaning, feature engineering, model training,
                  and evaluation. Collaborated on integrating model outputs into
                  a Flask-based web interface.
                </p>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> Jan 2022 - Jun 2022
                </div>
              </div>
            </div>

            {/* GenAI / RAG Project */}
            <div className='qualification__data'>
              <div>
                <h3 className='qualification__title'>
                  GenAI / RAG Engineer (Project)
                </h3>
                <span className='qualification__subtitle'>
                  AI Document Q&A (RAG) — GitHub
                </span>
                <p className='qualification__description'>
                  Built a Retrieval-Augmented Generation (RAG) pipeline with
                  document ingestion, chunking, embeddings, and retrieval for
                  grounded LLM responses. Used LangChain-style orchestration and
                  prompt design to improve relevance and reduce hallucinations.
                </p>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> 2025 - Present
                </div>
              </div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            {/* MLOps CI/CD Project */}
            <div className='qualification__data'>
              <div></div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>

              <div>
                <h3 className='qualification__title'>MLOps Engineer (Project)</h3>
                <span className='qualification__subtitle'>
                  MLOps CI/CD Pipeline — GitHub
                </span>
                <p className='qualification__description'>
                  Implemented reproducible ML workflows with experiment tracking
                  (MLflow), dataset/model versioning (DVC), and containerized
                  runs (Docker). Automated checks and workflows using GitHub
                  Actions for CI/CD reliability.
                </p>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> 2025 - Present
                </div>
              </div>
            </div>

            {/* ETL Project */}
            <div className='qualification__data'>
              <div>
                <h3 className='qualification__title'>Data Engineer (Project)</h3>
                <span className='qualification__subtitle'>
                  Azure CoinGecko ETL — GitHub
                </span>
                <p className='qualification__description'>
                  Built an ETL pipeline to extract data from the CoinGecko API,
                  transform time-series snapshots, and load into storage /
                  database. Designed for automation, scheduling, and clean data
                  outputs for analytics and ML.
                </p>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> 2025 - Present
                </div>
              </div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>
            </div>

            {/* MLflow Project */}
            <div className='qualification__data'>
              <div></div>

              <div>
                <span className='qualification__rounder'></span>
                <span className='qualification__line'></span>
              </div>

              <div>
                <h3 className='qualification__title'>
                  ML Engineer (Project)
                </h3>
                <span className='qualification__subtitle'>
                  Heart MLflow Project — GitHub
                </span>
                <p className='qualification__description'>
                  Ran model experiments and tracked metrics/parameters with
                  MLflow to compare model performance. Focused on reproducible
                  training runs, clear documentation, and result reporting.
                </p>
                <div className='qualification__calender'>
                  <i className='uil uil-calendar-alt'></i> 2025
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
